import React from "react";
import { SubsectionWithCheckboxes } from "./subsection/checkboxes";
import { SearchCommonField } from "../inputs/common-field";
import { SubsectionWithFields } from "./subsection/fields";

export const CitySection = () => {
    return (
        <>
            <SubsectionWithCheckboxes
                label={"What do you want to see in the city?"}
                name="cityAttractions"
            >
                <SearchCommonField name="city.historicalArchitecture" />
                <SearchCommonField name="city.modernArchitecture" />
                <SearchCommonField name="city.picturesqueStreets" />
                <SearchCommonField name="city.sacralBuildings" />
                <SearchCommonField name="city.castlesMansions" />
                <SearchCommonField name="city.panoramicVistas" />
                <SearchCommonField name="city.scenicDowntown" />
                <SearchCommonField name="city.shoppingPossibilities" />
                <SearchCommonField name="city.themeParks" />
            </SubsectionWithCheckboxes>
            <SubsectionWithFields>
                <SearchCommonField name="other.citySize" />
            </SubsectionWithFields>
        </>
    );
};
